import taskManagerApi from '@/features/shared/services/taskManagerApi';
import { ObjectUtil } from '@/features/shared/utils/ObjectUtil';
/**
 * Fetch travels with optional pagination, filters, and an "all" flag.
 */
export async function fetchTravels(page, filters, all = false) {
    try {
        const params = {
            ...(page ? { page } : {}),
            ...(filters || {}),
            ...(all ? { all: true } : {}),
        };
        const response = await taskManagerApi.get('/travel', { params });
        return response.data.data;
    }
    catch (error) {
        // Safely narrow the error
        if (error instanceof Error) {
            const serverError = error?.response?.data?.error;
            throw new Error(serverError?.details ?? serverError?.message ?? error.message);
        }
        else {
            throw new Error("Erreur inconnue lors de la récupération des travels");
        }
    }
}
/**
 * Create a new travel.
 */
export async function addTravel(travel) {
    try {
        const response = await taskManagerApi.post("/travel", travel);
        // logger?.info(`Travel "${travel.label}" created successfully.`, { travel });
        return response.data;
    }
    catch (error) {
        if (error instanceof Error) {
            const serverError = error?.response?.data?.error;
            throw new Error(serverError?.details ?? serverError?.message ?? error.message);
        }
        else {
            throw new Error("Erreur inconnue lors de la création de la travel");
        }
    }
}
/**
 * Update an existing travel.
 */
export async function updateTravel(travel) {
    try {
        const updatedTravel = ObjectUtil.omitField(travel, 'id');
        const response = await taskManagerApi.put(`/travel/${travel.id}`, updatedTravel);
        // logger?.info(`Travel "${travel.label}" updated successfully.`, { travel });
        return response.data;
    }
    catch (error) {
        if (error instanceof Error) {
            const serverError = error?.response?.data?.error;
            throw new Error(serverError?.details ?? serverError?.message ?? error.message);
        }
        else {
            throw new Error("Erreur inconnue lors de la modification de la travel");
        }
    }
}
/**
 * Delete a travel by its ID.
 */
export async function deleteTravel(id) {
    try {
        const response = await taskManagerApi.delete(`/travel/${id}`);
        // logger?.info(`Travel "${id}" deleted successfully.`);
        return response.data;
    }
    catch (error) {
        if (error instanceof Error) {
            const serverError = error?.response?.data?.error;
            throw new Error(serverError?.details ?? serverError?.message ?? error.message);
        }
        else {
            throw new Error("Erreur inconnue lors de la suppression de la travel");
        }
    }
}
export async function fetchTaskTravels(taskId) {
    const response = await taskManagerApi.get(`/task/${taskId}/travels`);
    return response.data.data.taskTravels;
}
